import React, { useState } from 'react';
import styled from 'styled-components';
import { Bell, Pin, Calendar, User, ChevronRight, Search, Filter, Eye, MessageSquare } from 'lucide-react';
import ContentLayout from '../../../Common/Component/ContentLayout';

const Container = styled.div`
  width: 100%;
`;

const FilterSection = styled.div`
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  margin-bottom: 20px;
  display: flex;
  gap: 15px;
  align-items: center;
  flex-wrap: wrap;
`;

const FilterSelect = styled.select`
  padding: 8px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  min-width: 120px;
  
  &:focus {
    outline: none;
    border-color: #3b82f6;
  }
`;

const SearchInput = styled.input`
  padding: 8px 12px;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  font-size: 14px;
  min-width: 200px;
  
  &:focus {
    outline: none;
    border-color: #3b82f6;
  }
`;

const SearchButton = styled.button`
  padding: 8px 12px;
  background: #3b82f6;
  color: white;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: background 0.2s;
  
  &:hover {
    background: #2563eb;
  }
`;

function SupportNotice() {
  const [categoryFilter, setCategoryFilter] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');
  const [sortBy, setSortBy] = useState('latest');

  return (
    <ContentLayout 
      title="공지사항"
      subtitle="AntsMarket의 새로운 소식과 중요한 안내사항을 확인하세요"
    >
      <Container>
        <FilterSection>
          <FilterSelect 
            value={categoryFilter} 
            onChange={(e) => setCategoryFilter(e.target.value)}
          >
            <option value="all">전체 카테고리</option>
            <option value="시스템">시스템</option>
            <option value="정책">정책</option>
            <option value="업데이트">업데이트</option>
            <option value="이벤트">이벤트</option>
            <option value="서비스">서비스</option>
          </FilterSelect>

          <FilterSelect 
            value={sortBy} 
            onChange={(e) => setSortBy(e.target.value)}
          >
            <option value="latest">최신순</option>
            <option value="oldest">과거순</option>
            <option value="views">조회순</option>
            <option value="title">제목순</option>
          </FilterSelect>

          <SearchInput
            type="text"
            placeholder="제목, 내용 검색..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />

          <SearchButton>
            <Search size={14} />
            검색
          </SearchButton>
        </FilterSection>
        
        <div>공지사항 목록이 여기에 표시됩니다...</div>
      </Container>
    </ContentLayout>
  );
}

export default SupportNotice;
